<template>
    <CCard class="mb-0 h-100">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title text-center">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody>
            <!-- Subscription -->
            <CContainer class="section px-5" fluid>
                <CRow class="my-4 px-3" alignHorizontal="between">
                        <h3>{{ $t('summary')}}</h3>
                        <CDropdown
                            color="primary"
                            :toggler-text="$t(text_dropdown)" 
                            class="lg_dropdown--simple"
                        >
                            <CDropdownItem 
                                v-for="(item,key) in list_coins" :key="key"
                                @click="currency_active = key"
                            >
                                {{ $t(`${item.text}_(${item.symbol})`) }}
                            </CDropdownItem>
                            
                        </CDropdown>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol sm="12" md="8">
                        <CCardGroup :deck="true">
                            <!-- Free plan -->
                            <CCard class="free_plan">
                                <CCardBody>
                                    <div class="d-flex">
                                        <span><CIcon :content="$options.icons.cilInfo" /></span><h4 class="free_plan__title">{{ $t('free_plan') }}</h4>
                                    </div>
                                    <p class="free_plan__description">
                                        {{ 
                                            $t('the_plan_ends_on') + ' ' + formatDateAdvance({ date: getDate({ next_days: 15 }), separator:'/'})
                                        }}
                                    </p>

                                    <!-- price -->
                                    <div class="free_plan__price price">
                                        <span class="price__amount">0,00</span><span class="price__currency">{{ currency }}</span> / <span class="price__pedriod_time"> {{$t('_month')}} </span>
                                    </div>
                                </CCardBody>
                            </CCard>
                            <!-- Details free plan -->
                            <CCard class="details_free_plan">
                                <CCardBody>
                                    <div class="d-flex">
                                        <h4 class="details_free_plan__title">{{ $t('use') }}</h4>
                                    </div>
                                    <p class="details_free_plan__subtitle">{{ $t('account_limits') }}</p>
                                    <div class="details_free_plan__bar" ></div>
                                    <ul class="details_free_plan__features">
                                        <li class="features_item">
                                            <div class="features_item--left">
                                                {{ $t('databases')}}
                                            </div>
                                            <div class="features_item--right">
                                                1
                                            </div>
                                        </li>
                                        <li class="features_item">
                                            <div class="features_item--left">
                                                {{ $t('recruitment_campaigns')}}
                                            </div>
                                            <div class="features_item--right">
                                                1
                                            </div>
                                        </li>
                                        <li class="features_item">
                                            <div class="features_item--left">
                                                {{ $t('delivery_campaigns')}}
                                            </div>
                                            <div class="features_item--right">
                                                1
                                            </div>
                                        </li>
                                        <li class="features_item">
                                            <div class="features_item--left">
                                                {{ $t('creativities')}}
                                            </div>
                                            <div class="features_item--right">
                                                {{ $t('limited') }}
                                            </div>
                                        </li>
                                        <li class="features_item">
                                            <div class="features_item--left">
                                                {{ $t('daily_contacts')}}
                                            </div>
                                            <div class="features_item--right">
                                                100
                                            </div>
                                        </li>
                                    </ul>

                                    <CLink class="details_free_plan__link"> {{ $t('select_monthly_plan') }}</CLink>
                                </CCardBody>
                            </CCard>
                        </CCardGroup>
                    </CCol>
                    <CCol sm="12" md="4">
                        <!-- Professional plan -->
                        <CCard class="professional_plan">
                            <CCardBody class="professional_plan__container">
                                <h4 class="professional_plan__title">{{ $t('professional_plan') }}</h4>
                                <p class="professional_plan__description">{{ $t('to_help_you_expand_your_business') }}</p>

                                <div class="professional_plan__price price">
                                    <div class="d-flex justify-content-center">
                                        <span class="price__text">{{ $t('from') }}</span>
                                    </div>
                                    <div>
                                        <span class="price__amount">{{ amount }}</span><span class="price__currency">{{ currency }}</span> / <span class="price__pedriod_time"> {{$t('_month')}} </span>
                                    </div>
                                </div>
                                <CButton class="professional_plan__button" :block="true"> {{ $t('start')}} </CButton>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
    
    
</template>

<script>

import StripeElement from "~/components/StripeElement";

import { mapGetters } from 'vuex';
import pageMixin from '~/mixins/page.js';
import dateMixin from '~/mixins/date.js';


import { cilSave, cilInfo } from '@coreui/icons';

export default {
    name: "SubscriptionPage",

    middleware: ['auth', 'import-stripe'],

    mixins: [ pageMixin, dateMixin],

    icons:{
        cilSave,
        cilInfo
    },

    components:{
        StripeElement
    },

    data() {
        return {
            stripe:{
                instance:null,
                elements:null
            },
            list_coins:{
                dollar:{
                    symbol:'$',
                    text:'dollar'
                },
                euro:{
                    symbol:'€',
                    text:'euro'
                }
            },
            list_prices:{
                dollar: "15,00",
                euro: "19,00"
            },
            currency_active:'euro',
        }
    },
    computed:{
        ...mapGetters({
            user:"auth/user"
        }),

        text_dropdown:function(){
            return `${this.list_coins[this.currency_active].text}_(${this.list_coins[this.currency_active].symbol})`
        },

        currency:function(){
            return this.list_coins[this.currency_active].symbol;
        },
        amount:function(){
            return this.list_prices[this.currency_active];
        }


        
    },

    
    methods: {
        async updateSubscription(){
            let subscriptions = await this.loadData({ 
                url: '/customer.api/GetSubscriptions',  
                method: 'GET'
            });
            this.subscription = subscriptions._items[0];
        },
        async updateData() {
            await this.updateSubscription();
        },
    },
    async mounted(){
        await this.updateData();
    },
    async created(){
        this.stripe.instance = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
        this.stripe.elements = this.stripe.instance.elements();
    }
    
}
</script>
<style scoped lang="scss">

    .free_plan{
        min-height: 24rem;
        & .free_plan__title{
            font-size: 1.2rem;
            font-weight: 700;
            margin-bottom: 1.5rem ;
            margin-left: 2rem;
        }

        & .free_plan__price{
            font-size: 2rem;
            font-weight: 900;
            margin-top: 2rem;
            font-family: Times, "Times New Roman", serif;
            & .price__currency{
                font-size: 1.3rem;
                display: inline-block;
                vertical-align:top;
            }
        }
    }

    .details_free_plan{
        min-height: 24rem;
        & .details_free_plan__title{
            font-size: 1.2rem;
            font-weight: 700;
            margin-bottom: 1.5rem ;
            margin-left: 2rem;
        }

        & .details_free_plan__bar{
            border:  5px solid blue;
            border-radius: 25px ;
        }

        & .details_free_plan__features{
            margin-top: 2rem ;
            margin-bottom: 1.7rem;
            list-style: none;
            padding-left: 0;
            & .features_item{
                color: rgba(128, 128, 128, 0.849);
                margin-bottom: 0.7rem;
                font-size: 0.9rem;
                display: flex;
                justify-content: space-between;
            }
        }

        & .details_free_plan__link{
            font-size: 1rem;
        }

    }

    .professional_plan{
        background-color: #f5f6fe;
        box-shadow: none !important;
        & .professional_plan__container{
            display: flex;
            // justify-content: center;
            align-items: center;
            flex-direction: column;

            & .professional_plan__title{
                color: #1d5be9;
                font-size: 3rem;
                font-family: Times, "Times New Roman", serif;
                font-weight: 900;
                margin-top: 2rem;
                margin-bottom: 2rem;
            }

            & .professional_plan__description{
                color: #8c9db8;
                margin-bottom: 3rem;
            }

            & .professional_plan__price{
                font-size: 2rem;
                font-family: Times, "Times New Roman", serif;
                font-weight: 900;
                margin-top: 2rem;
                & .price__text{
                    font-size: 1rem;
                }
                & .price__currency{
                    font-size: 1.3rem;
                    display: inline-block;
                    vertical-align:top;
                }
            }
        }

        & .professional_plan__button{
            background-color: #1d5be9;
            margin-top: 2rem;
            color: white;
            font-size: 1.3rem;
            padding: 1.3rem 0;
        }
        
    }

</style>
